import { supabase } from '../supabase';

const ts = () => new Date().toISOString();

// Soft-delete un registro por id
export async function softDelete(tabla, id) {
  return supabase.from(tabla).update({ eliminado: true, eliminado_en: ts() }).eq('id', id);
}

// Soft-delete todos los hijos de un padre (para cascade)
export async function softDeleteHijos(tabla, col, parentId) {
  return supabase.from(tabla)
    .update({ eliminado: true, eliminado_en: ts(), eliminado_con_id: parentId })
    .eq(col, parentId)
    .eq('eliminado', false);
}

// Restaurar un registro por id
export async function restaurar(tabla, id) {
  return supabase.from(tabla)
    .update({ eliminado: false, eliminado_en: null, eliminado_con_id: null })
    .eq('id', id);
}

// Restaurar todos los hijos que fueron eliminados en cascade con este padre
export async function restaurarHijos(tabla, parentId) {
  return supabase.from(tabla)
    .update({ eliminado: false, eliminado_en: null, eliminado_con_id: null })
    .eq('eliminado_con_id', parentId);
}
